export enum PlanType {
    CUMULATIVE_PERCENTAGE = 1
}